/* eslint-disable import/prefer-default-export */

export const Permissions = {
  BasicAcces: { 
    id: 'basicAccess', code : 100, display : "app_permissions.basic", shortDisplay : "BAC" 
  },
  UserView: { 
    id: 'userView', code : 109, display : "app_permissions.user_view", shortDisplay : "USR-VIEW" 
  },
  UserEdit: { 
    id: 'userEdit', code : 110, display : "app_permissions.user_edit", shortDisplay : "USR-EDIT" 
  },
  HGSSRead: { 
    id: "hgssRead", code: 201, display: "app_permissions.hgss_view", shortDisplay: "HGSSR"
  },
  HGSSMod: { 
    id: "hgssMod", code: 202, display: "app_permissions.hgss_edit", shortDisplay: "HGSSM"
  },
  HPSRead: { 
    id: "hpsRead", code: 301, display: "app_permissions.hps_view", shortDisplay: "HPSR"
  },
  HPSMod: { 
    id: "hpsMod", code: 302, display: "app_permissions.hps_edit", shortDisplay: "HPSM"
  },
  HPSSharedView: {
    id: 'HPSSharedView', code: 310, display: "app_permissions.hps_shared_view", shortDisplay: "HPSSHRVIEW"
  },
  HPSPlanVodicEdit: {
    id: 'HPSPlanVodicEdit', code: 311, display: "app_permissions.plan_vodic_edit", shortDisplay: "HPSPVEDT"
  },
  HPSPlanVodicView: {
    id: 'HPSPlanVodicView', code: 315, display: "app_permissions.plan_vodic_view", shortDisplay: "HPSPVVIEW"
  },
  HPSPlanUdrugaView: {
    id: 'HPSPlanUdrugaView', code: 312, display: "app_permissions.plan_udruga_view", shortDisplay: "HPSPUVIEW"
  },
  HPSStanicaPlanVodicaView: {
    id: 'HPSStanicaPlanVodicaView', code: 313, display: "app_permissions.stanica_plan_vodica_view", shortDisplay: "HPSSPVVIEW"
  },
  HPSKomisijaView: {
    id: 'HPSKomisijaView', code: 314, display: "app_permissions.komisija_view", shortDisplay: "HPSKOMVIEW"
  },
  SharedRead: {
    id: "sharedRead", code: 501, display: "app_permissions.shared_read", shortDisplay: "SHRR"
  },
  SharedMod: {
    id: "sharedMod", code: 502, display: "app_permissions.shared_edit", shortDisplay: "SHRM"
  },
  CommentsRead: {
    id: "commentsRead", code: 503, display: "app_permissions.comments_read", shortDisplay: "COMRD"
  },
  CommentsMod: {
    id: "commentsMod", code: 504, display: "app_permissions.comments_edit", shortDisplay: "COMMOD"
  },
  Administration: {
    id: 'administration', code: 900, display: "app_permissions.administration", shortDisplay: "ADM"
  },
  AdministrationOrgUsers: {
    id: 'administrationOrgUsers', code: 901, display: "app_permissions.administration_org_users", shortDisplay: "USADM"
  },
}